import { ReactElement } from "react";
import styled from "styled-components";
import InlineHtml from "../InlineHtml";

interface TableData {
  content?: string[][];
  withHeadings?: boolean;
}

// Tables scroll inside their own container — the page body must never scroll sideways
// on a phone because one table is wide.
const Scroll = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  font-size: 15px;
  line-height: 1.5;
  color: var(--app-color-text, #041723);

  td,
  th {
    border: 1px solid rgba(var(--app-color-text-rgb, 4, 23, 35), 0.12);
    padding: 10px 12px;
    text-align: left;
    min-width: 90px;
  }
  thead th {
    background: rgba(var(--app-color-text-rgb, 4, 23, 35), 0.04);
    font-weight: 700;
  }
`;

const TableBlock = ({ data }: { data: TableData }): ReactElement | null => {
  const rows = data.content ?? [];
  if (!rows.length) return null;
  const [head, ...body] = data.withHeadings ? [rows[0], ...rows.slice(1)] : [null, ...rows];
  return (
    <Scroll>
      <StyledTable>
        {head && (
          <thead>
            <tr>
              {head.map((cell, i) => (
                <th key={i}>
                  <InlineHtml html={cell} />
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {body.map((row, r) => (
            <tr key={r}>
              {(row ?? []).map((cell, c) => (
                <td key={c}>
                  <InlineHtml html={cell} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </Scroll>
  );
};

export default TableBlock;
